<template>
  <div>
    <div class="load full" v-if="percent >= 100">
      <div class="loadText">Keine freien Plätze</div>
      <div class="loadInfo">
        <div class="loadInfoGraph" :style="'width: 100%'"></div>
      </div>
    </div>
    <div class="load" v-else>
      <div class="loadText">
        {{ spaceLeft }} von {{ capacity }} verfügbar
      </div>
      <div class="loadInfo">
        <div class="loadInfoGraph" :style="'width:' + percent + '%'"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CourseWorkload",
  props: ["load", "capacity"],
  computed: {
    spaceLeft() {
      return Math.floor(this.capacity - this.load);
    },
    percent() {
      const percent = Math.floor((this.load / this.capacity) * 100);
      if (percent < 100) return percent;
      return 100;
    }
  }
};
</script>

<style scoped lang="scss">
.load {
  --loadHeight: 5px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;

  .loadText {
    width: calc(33.3333% - (var(--gridGapX) / 2));
    font-size: 0.8333rem;
    font-weight: var(--fontWeightBold);
    line-height: 1.1;
    color: (--midGray);
  }

  .loadInfo,
  .loadInfoGraph {
    height: var(--loadHeight);

    @media (min-width: 980px) {
      --loadHeight: 8px;
    }
  }

  .loadInfo {
    width: calc(66.6666% - (var(--gridGapX) / 2));
    background-color: var(--lightGray);
    border-radius: 10px;
    overflow: hidden;
  }

  .loadInfoGraph {
    background-color: var(--orange);
    border-right: 3px solid var(--white);

    &[style^="width: 0%"] {
      opacity: 0;
    }
  }

  &.full {
    .loadText {
      color: var(--orange);
    }

    .loadInfoGraph {
      border-right-width: 0;
    }
  }
}
</style>
